import { useNavigate } from 'react-router-dom';
import { storage } from '@/shared/utils';
import { logout as apiLogout } from '@/features/authorization/api/logout';

export const useAuth = () => {
  const navigate = useNavigate();

  const isAuthenticated = (): boolean => {
    const tokens = storage.getTokens();
    return tokens !== null && !storage.isTokenExpired();
  };

  const logout = (): void => {
    apiLogout();
    navigate('/login', { replace: true });
  };

  return {
    isAuthenticated,
    logout,
  };
};
